
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/window-door",
      function () {
        return require("private-next-pages/services/window-door/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/window-door"])
      });
    }
  